import styled, { CSSObject } from 'styled-components';
import getIconSize from './getIconSize';
import { Size } from './types';

interface SvgIconStyledProps {
  color?: 'primary' | 'secondary' | 'wfWhite' | 'wfBlack';
  size?: keyof typeof Size;
  sx?: CSSObject;
}

const SvgIconStyled = styled.span<SvgIconStyledProps>(
  ({ theme, size, color, sx }) => {
    const iconColor = color ? theme.color[color] : '';

    const styleSheet: CSSObject = {
      display: 'inline-flex',
      svg: {
        ...getIconSize(size),
        path: {
          fill: iconColor,
        },
      },
    };

    // TODO: try new approach
    // const styleSheet: CSSObject = {
    //   display: 'inline-flex',
    //   svg: {
    //     ...getIconSize(size),
    //     color: iconColor,
    //     path: {
    //       fill: 'currentColor',
    //     },
    //   },
    // };

    return {
      ...styleSheet,
      ...sx,
    };
  },
);

export { SvgIconStyled };
